/**
 * Format raw card-number input as the user types. Strips non-digits, caps the
 * length per network (Amex 15, others 16), and inserts spaces in the
 * conventional grouping (Amex 4-6-5; everyone else 4-4-4-4).
 *
 * Pure: no DOM, no caret math — the calling input controls cursor position.
 *
 * Owned by the shared checkout module so domain code (events, products,
 * subscription) consumes a single source of truth.
 */
export function formatCardNumber(value: string): string {
  let numericValue = value.replace(/\D/g, "");
  const isAmex = numericValue.startsWith("34") || numericValue.startsWith("37");

  if (isAmex) {
    numericValue = numericValue.slice(0, 15);
    if (numericValue.length <= 4) {
      return numericValue;
    }
    if (numericValue.length <= 10) {
      return `${numericValue.slice(0, 4)} ${numericValue.slice(4)}`;
    }
    return `${numericValue.slice(0, 4)} ${numericValue.slice(4, 10)} ${numericValue.slice(10)}`;
  }

  numericValue = numericValue.slice(0, 16);
  const chunks = numericValue.match(/.{1,4}/g);
  return chunks ? chunks.join(" ") : numericValue;
}
